import { render, staticRenderFns } from "./HomeDateBox.vue?vue&type=template&id=3fda0843&scoped=true&lang=pug"
import script from "./HomeDateBox.vue?vue&type=script&lang=ts"
export * from "./HomeDateBox.vue?vue&type=script&lang=ts"
import style0 from "./HomeDateBox.vue?vue&type=style&index=0&id=3fda0843&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fda0843",
  null
  
)

export default component.exports